import { TrackingClass } from 'components/TrackingClass';
import { CopyText } from '../CopyText';
import { UILogistics } from './utils';
import { ReactComponent as TrackingNumberIcon } from 'views/Conversation/Sider/assets/trackingNumber.svg';
import { ReactComponent as WarehouseTypeIcon } from 'views/Conversation/Sider/assets/warehouseType.svg';

interface BaseInfoProps {
  data: UILogistics;
  cols?: number;
}

const InfoItem = ({ value, icon }: { value: string; icon?: React.ReactNode }) => {
  return (
    <div className="flex items-center gap-1">
      <div className="w-4 h-4 flex-shrink-0">{icon}</div>
      <CopyText className="flex-1 min-w-0" text={value} title={value} />
    </div>
  );
};

const infoList = [
  {
    dataIndex: 'trackingNumber',
    icon: <TrackingNumberIcon />,
  },
  {
    dataIndex: 'firstMileTrackingNumber',
    icon: <TrackingNumberIcon />,
  },
  {
    dataIndex: 'lastMileTrackingNumber',
    icon: <TrackingNumberIcon />,
  },
  {
    dataIndex: 'plpNumber',
    icon: <TrackingNumberIcon />,
  },
  {
    dataIndex: 'shippingCarrier',
    icon: <WarehouseTypeIcon />,
  },
  {
    dataIndex: 'warehouseCode',
    icon: <WarehouseTypeIcon />,
  },
  {
    dataIndex: 'gxbLogisticsNo',
    icon: <TrackingNumberIcon />,
  },
  {
    dataIndex: 'logisticsNo',
    icon: <TrackingNumberIcon />,
  },
] as const;

export const BaseInfo = (props: BaseInfoProps) => {
  const { data, cols = 1 } = props;

  return (
    <div className={`bg-[#F7F9FA] rounded p-3 grid grid-rows-[1fr] gap-[10px] grid-cols-${cols}`}>
      {infoList.map((item) => {
        const dataValue = data[item.dataIndex];
        if (dataValue) {
          return <InfoItem key={item.dataIndex} value={dataValue} icon={item.icon} />;
        }
        return null;
      })}
      <TrackingClass trackingClass={data.trackingClass} />
    </div>
  );
};
